<template>
  <div id="lgpdw">
    <meu-menu :rotas="routes"/>
    <router-view />
  </div>
</template>

<script>
import { routes } from './routes';
import Menu from './components/Menu.vue'
export default {

  components: {
    'meu-menu' : Menu
  },

  data() {
    return {
      routes
    }
  }
}
</script>

<style>

#lgpdw {
  display: flex;
  min-height: 100vh;
}

@media (max-width: 678px) {
  #lgpdw {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue